module.exports = __webpack_public_path__ + "img/guide-12.2c047c69.jpg";